import React, { useState, useEffect } from 'react';
import ResponsiveModal from '../layout/ResponsiveModal';
import Swal from 'sweetalert2';

const ModalAsesor = ({ isOpen, onClose, initialData }) => {
  const [formData, setFormData] = useState({
    nombre: '',
    correo: '',
    telefono: '',
    empresa: '',
    interes: 'Timbrado corporativo',
    mensaje: ''
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (initialData?.motivo) {
      setFormData((prev) => ({
        ...prev,
        interes: initialData.motivo
      }));
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const portalId = '1735765';
      const formId = '31fd5863-be40-42d8-8d6b-61ef8455b3ba';
      const region = 'na1';

      const getCookie = (name) => {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? match[2] : null;
      };
      const hutk = getCookie('hubspotutk');

      const payload = {
        fields: [
          { name: 'firstname', value: formData.nombre },
          { name: 'email', value: formData.correo },
          { name: 'phone', value: formData.telefono },
          { name: 'company', value: formData.empresa },
          { name: 'message', value: `[Solución de interés: ${formData.interes}] ${formData.mensaje}` }
        ],
        context: {
          pageUri: window.location.href,
          pageName: document.title || 'Digital Factura - Asesor',
          ...(hutk ? { hutk } : {})
        }
      };

      const response = await fetch(
        `https://api-${region}.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        }
      );

      if (!response.ok) {
        throw new Error('HubSpot submission failed');
      }

      Swal.fire({
        title: '¡Solicitud Enviada!',
        text: 'Hemos recibido tus datos. Uno de nuestros ejecutivos comerciales se pondrá en contacto contigo en breve.',
        icon: 'success',
        confirmButtonColor: '#C8102E'
      });

      onClose();
      setFormData({
        nombre: '',
        correo: '',
        telefono: '',
        empresa: '',
        interes: 'Timbrado corporativo',
        mensaje: ''
      });
    } catch (err) {
      console.error('Error enviando asesor a HubSpot:', err);
      Swal.fire({
        title: 'Error',
        text: 'Ocurrió un error al enviar tu solicitud. Por favor intenta de nuevo.',
        icon: 'error',
        confirmButtonColor: '#C8102E'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <ResponsiveModal
      isOpen={isOpen}
      onClose={onClose}
      title="Contacta con un Asesor Especialista"
      subtitle="Recibe atención personalizada, cotizaciones a la medida o agenda una demostración sin costo."
      size="md"
    >
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
          <label className="df-form-label" htmlFor="asesor-nombre">Nombre completo *</label>
          <input
            id="asesor-nombre"
            type="text"
            name="nombre"
            required
            className="df-form-input"
            placeholder="Tu nombre completo"
            value={formData.nombre}
            onChange={handleChange}
          />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '14px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label className="df-form-label" htmlFor="asesor-correo">Correo electrónico *</label>
            <input
              id="asesor-correo"
              type="email"
              name="correo"
              required
              className="df-form-input"
              placeholder="tu@empresa.com"
              value={formData.correo}
              onChange={handleChange}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label className="df-form-label" htmlFor="asesor-telefono">Teléfono / Celular *</label>
            <input
              id="asesor-telefono"
              type="tel"
              name="telefono"
              required
              className="df-form-input"
              placeholder="(33) 1234 5678"
              value={formData.telefono}
              onChange={handleChange}
            />
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '14px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label className="df-form-label" htmlFor="asesor-empresa">Empresa / RFC (Opcional)</label>
            <input
              id="asesor-empresa"
              type="text"
              name="empresa"
              className="df-form-input"
              placeholder="Nombre de tu empresa o RFC"
              value={formData.empresa}
              onChange={handleChange}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label className="df-form-label" htmlFor="asesor-interes">Solución de interés *</label>
            <select
              id="asesor-interes"
              name="interes"
              className="df-form-input"
              value={formData.interes}
              onChange={handleChange}
            >
              <option value="Timbrado corporativo">Timbrado Corporativo (ERP)</option>
              <option value="Timbrado JSON">Timbrado JSON (Developers)</option>
              <option value="SICAI Web">SICAI Web (En la nube)</option>
              <option value="SICAI Pro">SICAI Pro (Escritorio)</option>
              <option value="SICAI Server">SICAI Server (En Red)</option>
              <option value="DeConect">SICAI DeConnect</option>
              <option value="SICAI XML">SICAI XML Descargas</option>
              <option value="Addendas">Addendas Comerciales</option>
              <option value="Desarrollo a la medida">Desarrollo de Software a la Medida</option>
            </select>
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
          <label className="df-form-label" htmlFor="asesor-mensaje">Comentarios o requerimientos</label>
          <textarea
            id="asesor-mensaje"
            name="mensaje"
            className="df-form-textarea"
            style={{ minHeight: '80px' }}
            placeholder="Describe brevemente tus dudas o requerimiento de facturación..."
            value={formData.mensaje}
            onChange={handleChange}
          />
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '8px' }}>
          <button type="button" className="df-btn df-btn-outline" onClick={onClose}>
            Cancelar
          </button>
          <button type="submit" className="df-btn df-btn-primary" disabled={loading}>
            {loading ? 'Enviando...' : 'Solicitar Asesoría'}
          </button>
        </div>
      </form>
    </ResponsiveModal>
  );
};

export default ModalAsesor;
